import { configureStore } from '@reduxjs/toolkit';
import authReducer from './slices/authSlice';
import menuReducer from './slices/menuSlice';
import {
  meetingReducer,
  participantReducer,
  actionReducer,
  dashboardReducer,
} from './slices/actionTracker';
import adminReducer from './slices/adminSlice';
import userReducer from './slices/userSlice';
import roleReducer from './slices/roleSlice';
import profileReducer from './slices/profileSlice';
import auditReducer from './slices/auditSlice';
import notificationReducer from './slices/actionTracker/notificationSlice';

export const store = configureStore({
  reducer: {
    auth: authReducer,
    menu: menuReducer,
    meetings: meetingReducer,
    participants: participantReducer,
    actions: actionReducer,
    admin: adminReducer,
    profile: profileReducer,
    roles: roleReducer,
    dashboard: dashboardReducer,
    audit: auditReducer,
    notifications: notificationReducer,
    users: userReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }),
});

export default store;